<template>

    <div class="home">
        <div class="banner"></div>
        <div class="options">
            <div class="pos">
                <div class="op_item" v-for="(item, index) in optionsList" :key="index">
                    <div class="op_img">
                        <img :src="item.img" alt="">
                    </div>
                    <div class="op_title">{{ item.title }}</div>
                    <div class="op_rem">
                        {{ item.rem }}
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="page1">
            <div class="p1_item">
                <div class="pq_i_t">10年+</div>
                <div class="pq_i_b">服务经验</div>
            </div>
            <div class="p1_item">
                <div class="pq_i_t">96.8%</div>
                <div class="pq_i_b">满意度</div>
            </div>
            <div class="p1_item">
                <div class="pq_i_t">100000+</div>
                <div class="pq_i_b">累计服务车辆</div>
            </div>
        </div> -->
        <div class="page2">
            <div class="p2_title">
                <div class="p2_title_img bg7"></div>
                <div class="p2_t">步骤</div>
                <!-- <div class="p2_t">服务步骤</div> -->
                <div class="p2_title_img bg8"></div>
            </div>
            <div class="nav_con">
                <div :class="['nav_item', navIndex == index && 'current']" v-for="(item, index) in navList" :key="index"
                    @click="toggNavFn(index)">
                    {{ item }}
                </div>
            </div>
            <div class="process">
                <div class="process_item" v-for="(item, index) in processList" :key="item">
                    <div class="process_item_con">
                        <div class="num">
                            <img :src="require(`@/assets/image/0${index + 1}.png`)" alt="">
                        </div>
                        <div class="pro_title">{{ item.title }}</div>
                        <div class="pro_rem" v-if="item.pList.length">
                            <p class="p" v-for="(key, k) in item.pList" :key="k">{{ key }}</p>
                        </div>
                    </div>
                    <div :class="['process_item_img', (index % 2 === 1) && 'order']">
                        <img :src="item.url" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="page3">
            <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025386691号</a>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
const navIndex = ref(0);
// const navList = ref([
//     '汽车美容',
//     '品质保养',
//     '专业维修',
//     '汽车喷漆',
// ])
const navList = ref([
    '美容',
    '保养',
    '维修',
    '喷漆',
])
const optionsList = ref([
    {
        title: '美容',
        rem: '通过精细洗车、漆面养护、内饰清洁、贴膜镀晶等，提升车辆颜值与防护，令爱车焕发新生，驾乘更愉悦。',
        img: require('@/assets/image/bg2.png')
    },
    {
        title: '保养',
        rem: '通过定期更换机油、滤芯、刹车片，并结合发动机深度养护与轮胎安全检测，延长车辆寿命，提升操控稳定性，保障驾驶安全。',
        img: require('@/assets/image/bg3.png')
    },
    {
        title: '维修',
        rem: '依托智能检测设备精准定位故障，采用原厂配件与技术规范，高效修复发动机、电路等核心系统，恢复车辆性能，确保安全品质。',
        img: require('@/assets/image/bg4.png')
    },
    {
        title: '喷漆',
        rem: '以精细打磨处理损伤，电脑调色匹配原厂色，环保工艺多层喷涂，修复划痕的同时增强漆面硬度与光泽，持久抵御日晒腐蚀，令车身焕然一新。',
        img: require('@/assets/image/bg5.png')
    },
]);
const contentList2 = ref([
    {
        url: require('@/assets/image/bg12.png'),
        title: '保养前准备',
        pList: [
            '• 预约：提前与4S店或专业维修店预约保养时间，告知车辆信息和保养需求。',
            '• 资料准备：携带车辆行驶证、保养手册等相关资料。',
            '• 检查车辆：保养前对车辆外观、内饰、功能等进行检查，记录车辆状况，以便与保养后对比。',
        ]
    },
    {
        url: require('@/assets/image/bg13.png'),
        title: '更换机油和机油滤清器',
        pList: [
            '• 排放旧机油：车辆举升后，打开油底壳放油螺栓，将旧机油排放到废油收集容器中。',
            '• 更换机油滤清器：用专用工具拆下旧的机油滤清器，在新滤清器密封圈上涂抹少量机油后安装。',
            '• 添加新机油：根据车辆使用手册要求，加入适量的新机油，添加后检查机油液位。',
        ]
    },
    {
        url: require('@/assets/image/bg14.png'),
        title: '检查和更换空气滤清器',
        pList: [
            '• 拆卸空气滤清器外壳：打开引擎盖，找到空气滤清器外壳，松开固定螺丝或卡扣，取下外壳。',
            '• 检查空气滤清器：取出滤芯，观察其脏污程度，若过脏则需更换。',
            '• 安装新的空气滤清器：将新滤芯安装回原位，盖好外壳并固定。',
        ]
    },
    {
        url: require('@/assets/image/bg15.png'),
        title: '检查和更换燃油滤清器',
        pList: [
            '• 释放燃油系统压力：可通过拆卸燃油泵保险丝或继电器，启动发动机使其熄火，多次启动以释放压力。',
            '• 拆卸燃油滤清器：找到燃油滤清器，根据其安装方式，使用工具松开油管接头和固定螺丝，取下滤清器。',
            '• 安装新的燃油滤清器：安装新滤清器，确保安装方向正确，连接好油管和固定装置。',
        ]
    },
    {
        url: require('@/assets/image/bg16.png'),
        title: '检查和更换火花塞',
        pList: [
            '• 拆卸点火线圈或分缸线：根据车辆发动机结构，依次拆下点火线圈或分缸线与火花塞的连接。',
            '• 拆卸火花塞：使用火花塞套筒扳手，按顺序拆下火花塞。',
            '• 检查火花塞：观察火花塞电极磨损、积碳情况，决定是否更换。',
        ]
    },
    {
        url: require('@/assets/image/bg17.png'),
        title: '检查制动系统',
        pList: [
            '• 检查制动液液位和品质：打开制动液储液罐，检查液位是否在规定范围内，观察制动液颜色和透明度，若变质则需更换。',
            '• 检查刹车片厚度：通过制动卡钳观察孔或拆卸轮胎后检查刹车片厚度，小于规定值时需更换。',
            '• 检查刹车盘：查看刹车盘表面是否有磨损、划痕、裂纹等，必要时进行打磨或更换。',
            '• 检查制动管路：查看制动管路有无渗漏、老化、破损等情况。',
        ]
    },
    {
        url: require('@/assets/image/bg18.png'),
        title: '检查底盘',
        pList: [
            '• 检查悬挂系统：查看减震器是否漏油，悬挂部件有无松动、变形，球头、胶套有无磨损。',
            '• 检查传动轴和半轴：查看传动轴防尘套是否破损，半轴有无松动和异常磨损。',
            '• 检查排气管：查看排气管有无破损、漏气，固定支架是否牢固。',
        ]
    },
    {
        url: require('@/assets/image/bg19.png'),
        title: '其他检查',
        pList: [
            '• 检查轮胎：查看轮胎磨损情况，测量胎压，清理轮胎花纹中的石子等杂物。',
            '• 检查灯光系统：检查大灯、转向灯、刹车灯、雾灯等灯光是否正常工作。',
            '• 检查雨刮器：查看雨刮片胶条是否老化、破损，测试雨刮器工作状态。',
        ]
    },
    {
        url: require('@/assets/image/bg20.png'),
        title: '保养后工作',
        pList: [
            '• 清理车辆：清洁车辆外观和内饰，清除保养过程中产生的污渍和杂物。',
            '• 复位保养提示：使用专业设备或按照车辆说明书方法，复位保养提示灯。',
            '• 交付车辆：向车主说明保养项目、更换的配件及车辆检查情况，交付车辆。',
        ]
    },
]);
const contentList1 = ref([
    {
        url: require('@/assets/image/bg21.png'),
        title: '预洗',
        pList: [
            '用高压水枪远距离喷射车身，从车顶开始，按引擎盖、挡风玻璃、车身侧面、车门、后备箱、轮胎轮毂的顺序，冲掉车身上大面积泥沙和灰尘，降低后续擦洗时沙粒对车漆的损伤。',
        ]
    },
    {
        url: require('@/assets/image/bg22.png'),
        title: '车身泡沫覆盖',
        pList: [
            '将专用洗车泡沫均匀喷洒在车身，用泡沫枪或喷壶操作，确保全车覆盖，等待1 - 2分钟，让泡沫充分分解污渍。',
        ]
    },
    {
        url: require('@/assets/image/bg23.png'),
        title: '擦洗车身',
        pList: [
            '用柔软的海绵或洗车手套，按从上到下顺序擦洗，注意动作轻柔，避免刮伤车漆，缝隙、边角处可用软毛刷辅助清洁。',
        ]
    },
    {
        url: require('@/assets/image/bg24.png'),
        title: '轮毂清洁',
        pList: [
            '喷轮毂清洁剂，用轮毂刷仔细刷洗，包括轮毂表面、辐条、刹车卡钳等部位，去除刹车粉尘、油污等，再用高压水枪冲洗干净。',
        ]
    },
    {
        url: require('@/assets/image/bg25.png'),
        title: '门边、后备箱边清洁',
        pList: [
            '打开车门、后备箱，用毛巾或刷子蘸取清洁剂，清洁边缘密封条、门槛、铰链等位置，这些地方易藏污纳垢，需重点清理。',
        ]
    },
    {
        url: require('@/assets/image/bg26.png'),
        title: '冲洗车身',
        pList: [
            '用高压水枪将车身泡沫彻底冲洗干净，从车顶开始，确保无泡沫残留，尤其是缝隙、排水孔处。',
        ]
    },
    {
        url: require('@/assets/image/bg27.png'),
        title: '擦洗车身',
        pList: [
            '干净柔软的大毛巾或麂皮，按车身顺序擦干，尽量吸干水分，减少水渍残留。',
        ]
    },
    {
        url: require('@/assets/image/bg28.png'),
        title: '内饰吸尘',
        pList: [
            '用吸尘器全面清理车内，包括座椅、地板、脚垫、中控台、储物箱等，吸出灰尘、杂物。',
        ]
    },
    {
        url: require('@/assets/image/bg29.png'),
        title: '内饰擦拭',
        pList: [
            '用内饰专用清洁剂喷在毛巾上，轻轻擦拭中控台、仪表盘、方向盘、换挡杆、车门内饰板等部位，去除污渍和灰尘，注意避免液体渗入电子设备。',
        ]
    },
    {
        url: require('@/assets/image/bg30.png'),
        title: '座椅清洁',
        pList: [
            '织物座椅用专用清洁剂和刷子清洁，再用干净毛巾擦干；真皮座椅用真皮护理剂擦拭，保养皮革，保持柔软有光泽。',
        ]
    },
    {
        url: require('@/assets/image/bg31.png'),
        title: '玻璃清洁',
        pList: [
            '用玻璃清洁剂喷在车窗、后视镜、挡风玻璃内外侧，用干净报纸或专用玻璃擦拭布擦拭，直至光洁无污渍。',
        ]
    },
    {
        url: require('@/assets/image/bg32.png'),
        title: '轮胎护理',
        pList: [
            '在轮胎表面涂抹轮胎光亮剂，提升轮胎外观，起到保护作用，防止老化、龟裂。',
        ]
    },
]);
const contentList3 = ref([
    {
        url: require('@/assets/image/bg33.png'),
        title: '接车与问诊',
        pList: [
            '• 车辆接待：维修人员热情接待车主，引导车辆进入维修接待区，记录车辆基本信息，如车型、车牌号、行驶里程等。',
            '• 故障问诊：向车主详细询问故障发生的时间、地点、症状、频率等信息，了解车辆近期的使用情况和维修历史。',
        ]
    },
    {
        url: require('@/assets/image/bg34.png'),
        title: '故障诊断',
        pList: [
            '• 初步检查：维修人员对车辆进行外观检查，查看有无明显的碰撞、划痕、变形等损伤，同时检查车辆的灯光、轮胎、制动等基本部件是否正常。',
            '• 系统检测：根据故障现象，使用专业的诊断设备，如汽车故障诊断仪，对车辆的发动机、变速器、电子控制系统等进行全面检测，读取故障码和相关数据。',
            '• 路试：在安全的道路上进行路试，模拟车主描述的故障场景，进一步观察车辆在行驶过程中的表现，如动力性能、换挡情况、转向和制动性能等，以确定故障的具体位置和原因。',
        ]
    },
    {
        url: require('@/assets/image/bg35.png'),
        title: '制定维修方案',
        pList: [
            '• 确定维修项目：根据故障诊断结果，维修人员制定详细的维修方案，明确需要维修或更换的部件、维修的具体步骤和所需的工时。',
            '• 费用估算：依据维修项目，核算维修所需的零部件费用、工时费用以及其他可能产生的费用，向车主说明维修费用和预计交车时间，待车主签字确认后，方可进行维修。',
        ]
    },
    {
        url: require('@/assets/image/bg36.png'),
        title: '维修作业',
        pList: [
            '• 车辆防护：在维修前，对车辆的内饰、座椅、方向盘等部位进行防护，防止在维修过程中造成污染或损坏。',
            '• 拆卸与维修：按照维修方案，使用合适的工具和设备，对故障部件进行拆卸、检查和维修。如需要更换零部件，确保使用的是符合车辆规格的正品配件。',
            '• 安装与调试：维修完成后，将拆卸的部件正确安装回车辆，并对相关系统进行调试，确保其恢复正常工作状态。例如，维修发动机后，要进行点火系统、燃油系统等的调试；维修制动系统后，要进行制动性能的测试和调整。',

        ]
    },
    {
        url: require('@/assets/image/bg37.png'),
        title: '质量检验',
        pList: [
            '• 自检：维修人员完成维修作业后，首先进行自我检查，确保维修项目符合质量标准，所有零部件安装牢固，各项性能指标达到规定要求。',
            '• 专检：由专业的质量检验人员对维修车辆进行全面检查，包括外观、内饰、机械部件、电子系统等各个方面，检查维修质量是否合格，是否存在遗漏的维修项目或新的问题。',
            '• 路试检验：再次进行路试，检验车辆在各种工况下的运行状况，如加速、减速、转弯、制动等，确保车辆的动力性能、操控性能、舒适性等都恢复到正常水平。',
        ]
    },
    {
        url: require('@/assets/image/bg38.png'),
        title: '交车与回访',
        pList: [
            '• 车辆清洁：在交车前，对车辆进行全面清洁，包括外观清洗和内饰吸尘，使车辆以整洁的状态交付给车主。',
            '• 交车说明：维修人员向车主详细介绍维修项目、更换的零部件、维修后的注意事项等，解答车主的疑问，并提供维修发票和相关的维修记录。',
            '• 回访：在车辆交付后的一定时间内，通过电话或短信等方式对车主进行回访，了解车主对维修服务的满意度，以及车辆维修后的使用情况，收集车主的意见和建议，以便不断改进维修服务质量。',
        ]
    },
])
const contentList4 = ref([
    {
        url: require('@/assets/image/bg39.png'),
        title: '前期准备',
        pList: [
            '• 车辆清洗：彻底清洗车辆，去除车身表面的灰尘、油污和杂质，确保喷漆表面干净。',
            '• 遮蔽保护：使用遮蔽纸和胶带对不需要喷漆的部位，如车窗、车灯、门把手、轮胎等进行仔细遮蔽，防止油漆喷到这些地方。',
        ]
    },
    {
        url: require('@/assets/image/bg40.png'),
        title: '表面处理',
        pList: [
            '• 打磨：用砂纸或打磨机对需要喷漆的部位进行打磨，以去除旧漆、锈迹和不平整的表面，增加油漆的附着力。打磨时要注意力度均匀，避免过度打磨造成车身变形。',
            '• 填补腻子：对于车身表面的凹陷、划痕等缺陷，用腻子进行填补和找平。待腻子干燥后，再次进行打磨，使其与周围表面平整光滑。',
        ]
    },
    {
        url: require('@/assets/image/bg41.png'),
        title: '底漆喷涂',
        pList: [
            '• 调配底漆：根据车辆颜色和要求，选择合适的底漆，并按照规定的比例调配好。',
            '• 喷涂底漆：使用喷枪将底漆均匀地喷涂在处理好的车身表面。一般需要喷涂2至3层，每层之间要等待适当的干燥时间，以确保底漆的厚度和质量。底漆的作用是提供良好的附着力和防锈性能。',
        ]
    },
    {
        url: require('@/assets/image/bg42.png'),
        title: '中途漆喷涂',
        pList: [
            '• 调配中途漆：如果需要更好的遮盖力和填充性，可以在底漆和色漆之间喷涂中途漆。调配好中途漆，其颜色通常为灰色或白色。',
            '• 喷涂中途漆：采用与喷涂底漆相同的方法，将中途漆均匀地喷涂在底漆表面。喷涂后进行干燥和打磨，使表面更加平整光滑。',
        ]
    },
    {
        url: require('@/assets/image/bg43.png'),
        title: '色漆喷涂',
        pList: [
            '• 调配色漆：根据车辆的原始颜色或车主指定的颜色，精确调配色漆。可以使用电脑配色系统或参考色卡进行调配，确保颜色准确。',
            '• 喷涂色漆：将调好的色漆倒入喷枪中，进行喷涂。一般需要喷涂3至4层，每层要薄而均匀，注意喷枪与车身表面的距离和角度保持一致，以获得良好的颜色效果和光泽度。每层色漆之间要等待足够的干燥时间。',
        ]
    },
    {
        url: require('@/assets/image/bg44.png'),
        title: '清漆喷涂',
        pList: [
            '• 调配清漆：选择质量好的清漆，并按照说明书的要求进行调配，加入适量的固化剂和稀释剂。',
            '• 喷涂清漆：在色漆完全干燥后，喷涂清漆。清漆可以增加漆面的光泽度、硬度和耐磨性。一般喷涂2至3层，每层干燥后进行适当的打磨和抛光，以达到理想的效果。',
        ]
    },
    {
        url: require('@/assets/image/bg45.png'),
        title: '干燥与抛光',
        pList: [
            '• 干燥：喷漆完成后，将车辆停放在通风良好的干燥室或自然环境中，让油漆充分干燥。干燥时间根据油漆类型和环境温度、湿度等因素而定，一般需要数小时至数天不等。',
            '• 抛光：待油漆完全干燥后，使用抛光机和抛光蜡对漆面进行抛光处理，去除表面的细微瑕疵和颗粒，使漆面更加光滑亮丽，恢复其原有的光泽度。',
        ]
    },
    {
        url: require('@/assets/image/bg46.png'),
        title: '质量检查与收尾',
        pList: [
            '• 质量检查：对喷漆后的车辆进行全面检查，查看漆面是否有流漆、橘皮、气泡、色差等缺陷。如有问题，及时进行修复和调整。',
            '• 去除遮蔽物：将之前遮蔽的部位的遮蔽纸和胶带小心去除，注意不要刮伤漆面。',
            '• 清洁车辆：再次清洁车辆，去除残留的灰尘和杂物，将车辆交付给车主。',
        ]
    },
])
const processList = computed(() => {
    let obj = {
        0: contentList1.value,
        1: contentList2.value,
        2: contentList3.value,
        3: contentList4.value,
    }
    return obj[navIndex.value]
});
const currVal = ref(0);
const carChange = (val) => {
    currVal.value = val;

};
const toggNavFn = (index) => {
    navIndex.value = index;
}
</script>

<style scoped lang="scss">
.home {
    position: relative;
    width: 100%;

    .page1 {
        width: 100%;
        height: 40rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 45rem;
        background-image: url("@/assets/image/bg6.png");
        background-size: 100% 100%;

        .p1_item {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .pq_i_b {
                margin-top: 0.4rem;
                color: rgba(255, 255, 255, 0.5);
                font-size: 1.8rem;
                line-height: 2.8rem;
            }

            .pq_i_t {
                font-size: 4.8rem;
                line-height: 6.4rem;
                font-weight: 600;
                color: #fff;
            }
        }
    }

    .page2 {
        margin-top: 12rem;

        .process {
            margin-top: 8.8rem;
            display: flex;
            align-items: center;
            flex-direction: column;

            .process_item {
                display: flex;
                align-items: center;
                margin-bottom: 9.6rem;

                .process_item_con {
                    width: 60rem;
                    padding: 0 6.4rem;

                    .pro_rem {
                        font-size: 1.6rem;
                        line-height: 2.4rem;
                        color: #0A1B33;

                        .p {
                            margin-bottom: 1.8rem;
                        }
                    }

                    .pro_title {
                        font-size: 4rem;
                        line-height: 6rem;
                        font-weight: 600;
                        color: #0A1B33;
                        margin-bottom: 1.8rem;
                    }

                    .num {
                        width: 10rem;
                        height: 4.8rem;
                    }
                }

                .process_item_img {
                    width: 60rem;
                    height: 40rem;

                    &.order {
                        order: -1;
                    }
                }
            }
        }

        .nav_con {
            height: 20.4rem;
            margin-top: 2.4rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(255, 255, 255, 0.9);
            backdrop-filter: blur(1rem);

            .nav_item {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 26.4rem;
                height: 7.6rem;
                font-size: 2rem;
                color: #264AFF;
                font-weight: 600;
                background-image: url("@/assets/image/bg10.png");
                background-size: 100% 100%;
                cursor: pointer;

                &.current {
                    color: #fff;
                    background-image: url("@/assets/image/bg11.png");
                    background-size: 100% 100%;
                }
            }

        }

        .p2_title {
            display: flex;
            justify-content: center;

            .p2_t {
                font-size: 4rem;
                line-height: 6rem;
                font-weight: 600;
                color: #0A1B33;
            }

            .p2_title_img {
                width: 4.2rem;
                height: 4.2rem;
                background-size: 100% 100%;
            }

            .bg7 {
                background-image: url("@/assets/image/bg7.png");
                margin-right: 1.1rem;
            }

            .bg8 {
                background-image: url("@/assets/image/bg8.png");
                margin-left: 1.1rem;
            }
        }
    }

    .page3 {
        height: 32rem;
        background-image: url("@/assets/image/bg9.png");
        display: flex;
        align-items: center;
        justify-content: center;

        a {
            color: #fff;
        }
    }

    .options {
        position: relative;
        height: 45.8rem;
        display: flex;
        justify-content: center;
        background: #F5F7FA;

        .pos {
            position: absolute;
            width: 100%;
            height: 100%;
            top: -9.6rem;
            display: flex;
            justify-content: center;

            .op_item {
                width: 28.2rem;
                height: 100%;
                background: rgba(255, 255, 255, 0.8);
                padding: 2.4rem;
                backdrop-filter: blur(1rem);
                cursor: pointer;

                &:not(:last-child) {
                    margin-right: 2.4rem;
                }

                .op_rem {
                    margin-top: 1.6rem;
                    font-size: 1.4rem;
                    line-height: 2rem;
                    color: rgba(10, 27, 51, 0.7);
                }

                .op_title {
                    text-align: center;
                    margin-top: 2.4rem;
                    font-size: 2.4rem;
                    line-height: 3.6rem;
                    font-weight: 600;
                    color: #0A1B33;
                }

                .op_img {
                    width: 23.4rem;
                    height: 23.4rem;
                }
            }
        }
    }

    .banner {
        width: 100%;
        height: 72rem;
        background-image: url("@/assets/image/bg47.png");
        // background-image: url("@/assets/image/banne1.png");
        background-size: 100% 100%;
    }
}

img {
    width: 100%;
    height: 100%;
}
</style>